export class ToolsSideNavigationTree {
    static topItems = (parentId: string) => [
        {
            id: `${parentId}_1`,
            parentId,
            name: 'TOOLS_LOT_UNIT',
            path: '/tools/lotunit',
            icon: '',
            text: 'Lot / Unit Management',
            tooltip: 'LotUnit',
            items: []
        },
        {
            id: `${parentId}_2`,
            parentId,
            name: 'TOOLS_IMPORT',
            path: null,
            icon: '',
            text: 'Import',
            tooltip: 'Import',
            items: [
                {
                    id: `${parentId}_2_1`,
                    parentId: `${parentId}_2`,
                    name: 'ACH_IMPORT',
                    path: '/tools/achimport',
                    icon: '',
                    text: 'Owner ACH Setup',
                    tooltip: 'Owner ACH Setup',
                    items: []
                },
                {
                    id: `${parentId}_2_2`,
                    parentId: `${parentId}_2`,
                    name: 'VENDOR_IMPORT',
                    path: '/tools/vendorimport',
                    icon: '',
                    text: 'Vendor',
                    tooltip: 'Vendor',
                    items: []
                },
                {
                    id: `${parentId}_2_3`,
                    parentId: `${parentId}_2`,
                    name: 'CORP_INVOICE_UPLOAD',
                    path: '/tools/corpinvoiceupload',
                    icon: '',
                    text: 'Corp Invoice',
                    tooltip: 'Corp Invoice',
                    items: []
                },
                {
                    id: `${parentId}_2_4`,
                    parentId: `${parentId}_2`,
                    name: 'LOT_LOAD_IMPORT',
                    path: '/tools/lotloadimport/batches',
                    icon: '',
                    text: 'Lot Load',
                    tooltip: 'Lot Load',
                    items: []
                },
                {
                    id: `${parentId}_2_5`,
                    parentId: `${parentId}_2`,
                    name: 'AR_LOAD_IMPORT',
                    path: '/tools/arload/batches',
                    icon: '',
                    text: 'AR Load',
                    tooltip: 'AR Load',
                    items: []
                }
            ]
        },
        {
            id: `${parentId}_3`,
            parentId,
            name: 'EMPLOYEE_MANAGEMENT',
            path: '/tools/employee-management',
            icon: '',
            text: 'Employee Management',
            tooltip: 'EmployeeManagement',
            items: []
        },
        {
            id: `${parentId}_4`,
            parentId,
            name: 'USER_SETUP',
            path: '/tools/user-setup',
            icon: '',
            text: 'User Setup',
            tooltip: 'User Setup',
            items: []
        },
        {
            id: `${parentId}_5`,
            parentId,
            name: 'MANAGE_MY_PROFILE',
            path: '/tools/manage-my-profile',
            icon: '',
            text: 'Manage My Profile',
            tooltip: 'Manage My Profile',
            items: []
        },
        {
            id: `${parentId}_6`,
            parentId,
            name: 'PORTAL_USER_MANAGEMENT',
            path: '/tools/portalusermanagement',
            icon: '',
            text: 'Portal User Management',
            tooltip: 'Portal User Management',
            items: []
        },
        {
            id: `${parentId}_7`,
            parentId,
            name: 'LOCATION_MANAGEMENT',
            path: '/tools/location-management',
            icon: '',
            text: 'Locations/Branches',
            tooltip: 'Location Management',
            items: []
        },
        {
            id: `${parentId}_8`,
            parentId,
            name: 'LOCATION_SATELLITE_OFFICE_MANAGEMENT',
            path: '/tools/location-satellite-office-management',
            icon: '',
            text: 'Location Satellite Offices',
            tooltip: 'Location Satellite Offices',
            items: []
        },
        {
            id: `${parentId}_9`,
            parentId,
            name: 'BANKING_PARTNER_LOCATION_REMIT_TO_ADDRESS',
            path: '/tools/banking-partner-location-remit-to-address',
            icon: '',
            text: 'Remit To Addresses',
            tooltip: 'Remit To Addresses',
            items: []
        },
        {
            id: `${parentId}_10`,
            parentId,
            name: 'APPLICATION_INSTALLS',
            path: '/tools/application-installs',
            icon: '',
            text: 'Application Installs',
            tooltip: 'Application Installs',
            items: []
        }
    ];

    static communityItems = (parentId: string) => [
        {
            id: `${parentId}_1`,
            parentId,
            name: 'TOOLS_LOT_UNIT',
            path: '/tools/:communityId/lotunit',
            icon: '',
            text: 'Lot / Unit Management',
            tooltip: 'LotUnit',
            items: []
        },
        {
            id: `${parentId}_2`,
            parentId,
            name: 'COMMUNITY_MANAGE_PROPERTY',
            path: '/manage-property/:communityId/add-property',
            icon: '',
            text: 'Add Property',
            tooltip: 'Add Property',
            items: []
        }
    ];
}
